import styled from 'styled-components';

export const ContainerFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

export const ContentToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AlignToggle = styled.div`
  display: grid;
  gap: 3px;
`;
